import { AxiosError } from 'axios';
import { UserNotAuthorizedError } from '../../errors/userNotAuthorized';

const UNAUTHORIZED_STATUS_CODE = 401;

export const handleApiError = (error: unknown) => {
    if (error instanceof AxiosError) {
        if (error.response?.status === UNAUTHORIZED_STATUS_CODE) {
            return new UserNotAuthorizedError();
        }
    }

    return error;
};
